// Событие «вебхук ответил 401» — гейт авторизации отверг токен логина.
// AuthWrapper на него разлогинивает. Событием, а не импортом, чтобы не заводить
// цикл n8n-fetch → AuthWrapper → n8n-fetch.
export const AUTH_401_EVENT = 'auth-unauthorized';

// Сами auth-вебхуки из разлогина исключены: /webhook/auth-check в режиме валидатора
// отвечает 401 на любой чужой/пустой токен (в т.ч. когда его дёргают напрямую),
// а проверка сессии (POST того же пути) читает 401 как fail-open.
const AUTH_URL_RE = /\/webhook\/auth-/;

// detail.token — токен, с которым ушёл запрос: 401 по старой сессии может прийти уже
// после нового логина, и разлогинивать свежую сессию из-за него нельзя.
const notifyIfUnauthorized = (url, token, res) => {
  if (res && res.status === 401 && typeof window !== 'undefined' && !AUTH_URL_RE.test(String(url))) {
    window.dispatchEvent(new CustomEvent(AUTH_401_EVENT, { detail: { token: token || null } }));
  }
  return res;
};

export async function n8nFetch(url, options = {}) {
  const key = process.env.GATSBY_N8N_API_KEY;
  const { timeoutMs, retries = 0, ...fetchOptions } = options;
  const headers = { ...(fetchOptions.headers || {}) };
  if (key) headers['X-API-Key'] = key;
  // Токен логина (base64url(claims).hmac): n8nFetch — основной канал к вебхукам,
  // поэтому заголовок ставим здесь. Мимо него остались только киоски без логина
  // (`pages/inout.js`, `components/AttendanceScene.js` — пути `inout*` в исключениях
  // гейта). Старые сессии без токена ведут себя как раньше: гейт до enforce на
  // отсутствие заголовка не реагирует.
  let token = null;
  if (typeof window !== 'undefined') {
    try {
      token = localStorage.getItem('analytics-token');
      if (token) headers['X-Auth-Token'] = token;
    } catch {
      /* приватный режим / доступ к localStorage закрыт — запрос уходит без токена */
    }
  }

  if (!timeoutMs) {
    return fetch(url, { ...fetchOptions, headers }).then((res) => notifyIfUnauthorized(url, token, res));
  }

  let lastErr;
  for (let attempt = 0; attempt <= retries; attempt++) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    try {
      const res = await fetch(url, { ...fetchOptions, headers, signal: controller.signal });
      clearTimeout(timer);
      return notifyIfUnauthorized(url, token, res);
    } catch (err) {
      clearTimeout(timer);
      lastErr = err;
      const stalled = err.name === 'AbortError' || err.name === 'TypeError';
      if (!stalled || attempt === retries) throw err;
    }
  }
  throw lastErr;
}
